import { FilterOperator } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { withPermissionsModule } from '@/utils/withPermissionsModule';

import { ApplicationList } from '../../../shared/components/ApplicationList/ApplicationList';

const AgentApplicationsList = () => {
  const { merchantId, agentId } = useParams();

  if (!merchantId || !agentId) return <></>;

  const agentFilter = [
    {
      field: 'agent_id',
      operator: FilterOperator.EQUAL,
      value: agentId,
    },
  ];

  return <ApplicationList merchantId={merchantId} agentId={agentId} filters={agentFilter} />;
};

export const AgentApplicationsListModule = withPermissionsModule(AgentApplicationsList);
